import React from 'react';
import Svg from "../Svg";

const TrackTypeBlackIcon = props => (
   <Svg width="30px" height="30px" viewBox="30 30">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
         <g transform="translate(-25.000000, -592.000000)">
            <g transform="translate(24.000000, 453.000000)">
               <g transform="translate(1.000000, 139.000000)">
                  <circle fill="#A7A7A7" fillRule="evenodd" cx="15" cy="15" r="15"/>
                  <circle fill="#000000" fillRule="evenodd" cx="15" cy="15"
                          r="11.6666667"/>
                  <text
                     fontFamily="MapFont, Open Sans" fontSize="14" fontWeight="normal"
                     fill="#FFFFFF"
                  >
                     <tspan x="7.69889323" y="19.0833333">5F</tspan>
                  </text>
               </g>
            </g>
         </g>
      </g>
   </Svg>
);

export default TrackTypeBlackIcon;
